import React from 'react';
import MediaQuery from 'react-responsive';

const DesktopMediaQuery = props => <MediaQuery minWidth={992} {...props}/>;
const MobileMediaQuery = props => <MediaQuery maxWidth={992} {...props}/>;

export {
  DesktopMediaQuery,
  MobileMediaQuery,
};


// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/MediaQueries.jsx